/**
 * Plain constants without zod, so browser bundles that only need them (Admin_Portal,
 * Operator_Console via @macksons/web-client) tree-shake the zod schemas away
 * (`"sideEffects": false`). Re-exported from `common.ts` and `idempotency.ts`.
 */
export const STAFF_ROLES = [
    'group_admin',
    'tenant_admin',
    'finance',
    'outlet_staff',
    'dealer_staff',
];
/** Header carrying the client-supplied Idempotency_Key (Req 6.4). */
export const IDEMPOTENCY_HEADER = 'Idempotency-Key';
/** Header carrying the tenant a staff request acts on (checked by TenantGuard, Req 2.6). */
export const TENANT_HEADER = 'X-Tenant-Id';
/** Header carrying the request correlation identifier (Req 30.2). */
export const REQUEST_ID_HEADER = 'X-Request-Id';
//# sourceMappingURL=constants.js.map